import React, { useEffect, useState } from "react";

import {  useParams } from "react-router-dom";

import Header from "../layout/header";
import useAxios from "../utils/useAxios";
import { useQuery } from "react-query";
import IP from "../variable";

import { useMutation } from "react-query";
import toast from "react-hot-toast";

import { formatTime } from "../utils/formatTime";

import greenPatternFull from '../assets/images/bottom-pattern copy.png'
import greenPatternHalf from '../assets/images/bottom-pattern.png'



const SlotPage = () => {

    const [bookID, setBookID] = useState(null)
    

    let api = useAxios()

    const { id } = useParams();

    const { isLoading, isError, error, data, isSuccess, refetch } = useQuery(
        `slot-information-${id}`,
        async () => api.get(`${IP}/company/meeting-investors/${id}`),
        { cacheTime: 0 }
    );

    const  slotInformation = data?.data ?? {}

    useEffect(() => {
        if (bookID){
            bookMutation.mutate(bookID)
        }
    }, [bookID])

  const sendBook = (id) => {
    return api.post(`/company/register-meeting/${id}`);
  };

  const bookMutation = useMutation(sendBook, {
    onSuccess: (res) => {
      toast.success('Meeting Booked');
      setBookID(null)
      refetch()
    },
    onError: (res) => {
        console.log(res)
        setBookID(null)
    //   toast.error(res?.response?.data?.message); // onResponse("Something went wrong", "error");
    },
  });



    return (
        <div className="dashboard-page">
            <Header slotInformation={slotInformation} isSlotPage={true} companyName={slotInformation?.company}/>
            
            <div className="container mt-4">
            
           <div className="table-header">
                {slotInformation?.investors?.length}/{slotInformation?.participants ?? 4} {slotInformation?.investors?.length > 0 ? 'Investors' : 'Investor'}
            </div>

                {

                    slotInformation?.investors?.length > 0 ?

                    slotInformation?.investors?.map((investor) => (
                
               <div className="custom-card" key={investor.id}>
                   <span>
                       {investor?.name ?? '-'}
                   </span>

                   <span className="highlight">
                       {investor?.company ?? '-'}
                   </span>
                          

               </div>
                    ))
                    :
                     <div className="text-center">
                        <p>No Records Found</p>
                    </div>
         }

        </div>
        <div className="container">

        <span className="d-none d-sm-block pb-3">
                <div className="row">
                    {/* <div className="col-6 d-flex align-items-center">
                        <span style={{fontWeight: 'bold'}}>Media Partner | <img style={{height: '30px'}} src={mediaPartner} alt="" /></span>
                    </div> */}
                    <div className="col-12 d-flex justify-content-end">
                        <img className="green-pattern" src={greenPatternFull} alt="" />
                    </div>
                </div>

                </span>

            <span className="d-block d-sm-none">

                <img className="green-pattern" src={greenPatternHalf} alt="" />
            
                {/* <span style={{position: 'absolute', bottom: 0, left: '10px', marginBottom: '10px', fontWeight: 'bold'}}>Media Partner | <img style={{height: '30px'}} src={mediaPartner} alt="" /></span> */}

            </span>
        </div>
        </div>
    );
};

export default SlotPage;
